import React from 'react';
import '../css/GiftcardRenewalError.css'; // Import the CSS file

function GiftcardRenewalError() {
  return (
    <div className="giftcard-renewal-error-container">
      <div className="logo-container">
        <img src={`${process.env.REACT_APP_ASSETS_URL}/logo.png`} alt="Logo" className="logo" />
      </div>
      <h1>:(</h1>
      <h3>Non è stato possibile rinnovare la Gift Card.</h3>
      <button className="button" onClick={() => window.location.href=`mailto:${process.env.REACT_APP_EMAIL}`}>
        Contatta il Supporto
      </button>
    </div>
  );
}

export default GiftcardRenewalError; 